import React, { useState } from "react";
import { SingleDatePicker, isInclusivelyBeforeDay } from "react-dates";
import "react-dates/initialize";
import "react-dates/lib/css/_datepicker.css";
import moment from "moment";
import { useDispatch, useSelector } from "react-redux";
import { updateAskVyrillState, updateCustomDate, updateDashboardState } from "../Actions";

const CustomDateAskVyrill = () => {
  const [startDateFocused, setStartDateFocused] = useState(null);
  const [endDateFocused, setEndDateFocused] = useState(null);
  const dispatch = useDispatch();
  const custom_start_date = useSelector(
    (state) => state.askVyrill.custom_start_date
  );
  const custom_end_date = useSelector(
    (state) => state.askVyrill.custom_end_date
  );

  const handleStartDateChange = (newDate) => {
    dispatch(
      updateAskVyrillState({
        custom_start_date: newDate,
      })
    );
  };
  const handleEndDateChange = (newDate) => {
    dispatch(
        updateAskVyrillState({
          custom_end_date: newDate,
        })
      );
  };

  const handleStartDateFocusChange = ({ focused }) => {
    setStartDateFocused(focused);
  };
  const handleEndDateFocusChange = ({ focused }) => {
    setEndDateFocused(focused);
  };

  const renderMonthElement = ({ month, onMonthSelect, onYearSelect }) => {
    const currentYear = moment().year();
    const yearsToDisplay = 15;

    return (
      <div
        style={{
          display: "flex",
          justifyContent: "center",
        }}
      >
        <div style={{ marginRight: "10px" }}>
          <select
            className="month-dropdown"
            value={month.month()}
            onChange={(e) => onMonthSelect(month, e.target.value)}
          >
            {moment.months().map((label, value) => (
              <option key={value} value={value}>
                {label}
              </option>
            ))}
          </select>
        </div>
        <div>
          <select
            className="year-dropdown"
            value={month.year()}
            onChange={(e) => onYearSelect(month, e.target.value)}
          >
            {Array.from(
              { length: yearsToDisplay + 1 },
              (_, i) => currentYear - i
            ).map((year) => (
              <option key={year} value={year}>
                {year}
              </option>
            ))}
          </select>
        </div>
      </div>
    );
  };

  return (
    <div className="d-flex align-items-center custom-date-picker">
      <span className="me-1 ms-1">From</span>
      <span className="me-1">
        <div
          style={{
            border: "1px solid #BCBCBCE5",
            height: "26px",
          }}
        >
          <SingleDatePicker
            placeholder="start-date"
            date={custom_start_date}
            onDateChange={handleStartDateChange}
            focused={startDateFocused}
            onFocusChange={handleStartDateFocusChange}
            id="your_unique_isd_start"
            numberOfMonths={1}
            showDefaultInputIcon={false}
            hideKeyboardShortcutsPanel
            renderMonthElement={renderMonthElement}
            isOutsideRange={(day) => !isInclusivelyBeforeDay(day, moment())}
          />
        </div>
      </span>
      <span className="me-1">To</span>
      <span>
        <div
          style={{
            border: "1px solid #BCBCBCE5",
            height: "26px",
          }}
        >
          <SingleDatePicker
            placeholder="end-date"
            date={custom_end_date}
            onDateChange={handleEndDateChange}
            focused={endDateFocused}
            onFocusChange={handleEndDateFocusChange}
            id="your_unique_isd_end"
            numberOfMonths={1}
            showDefaultInputIcon={false}
            hideKeyboardShortcutsPanel
            renderMonthElement={renderMonthElement}
            isOutsideRange={(day) => !isInclusivelyBeforeDay(day, moment())}
          />
        </div>
      </span>
    </div>
  );
};

export default CustomDateAskVyrill;